import { render, staticRenderFns } from "./AdminAcademicCategories.html?vue&type=template&id=1e711bbf&scoped=true&"
import script from "./AdminAcademicCategories.vue?vue&type=script&lang=js&"
export * from "./AdminAcademicCategories.vue?vue&type=script&lang=js&"
import style0 from "./AdminAcademicCategories.scss?vue&type=style&index=0&id=1e711bbf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e711bbf",
  null
  
)

export default component.exports